<template>
  <v-container>
    <v-card
        class="mx-auto"
        max-width="344"
    >
      <v-card-text>
        <div>J'aurai besoin de combien de</div>
        <p class="text-h4 text--primary">
          Fruits Secs
        </p>
        <div>
          <v-text-field
              v-model="collaborateur"
              label="Nombre de collaborateurs"
              :rules="rules"
              hide-details="auto"
          ></v-text-field>
          <v-select
              v-model="frequence"
              :items="frequences"
              label="Fréquence"
          ></v-select>
        </div>
      </v-card-text>
      <v-card-actions>
        <p> Soit {{ equival500g }} bocaux de 500g</p>
      </v-card-actions>
      <v-card-actions>
        <p> Soit {{ equival700g }} bocaux de 700g</p>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "CalculatorFsecs",
  data: () => ({
    rules: [
      value => !!value || 'Required.',
    ],
    collaborateur: 0,
    poidsMoy:35,
    frequences: [
      4.33,
      2.17,
      1],
    frequence: 0,
  }),
  computed:{
    calculCafe(){
      return Math.round(this.collaborateur * this.poidsMoy * this.frequence)
    },
    equival500g(){
      return Math.round(this.calculCafe/500)
    },
    equival700g(){
      return Math.round(this.calculCafe/700)
    }
  }
}
</script>

<style scoped>

</style>